import React, { useState } from "react";
import Properties from "../components/Properties/Properties";

const PropertiesPage = () => {
  return <Properties />;
};

export default PropertiesPage;
